<template>
  <div class="sm-ac" :class="{'sm-hidden' : curMode === 'category'}">
    <div class="sm-wrapper">
      <div class="sm-ac__wrapper">
        <div class="sm-ac__set sm-ac__set_main">

          <div class="sm-ac-block">
            <ul>
              <li v-for="(history,index) in storedHistory" :key="'history_' + history.name">
                <button
                    @click="toSearch(history.name, 0)"
                    class="sm-ac-block__button sm-ac-history"
                    type="button">
                  <span class="sm-ac-history__text"><b></b>{{ history.name }}</span>
                  <span @click.stop="deleteFromHistory(index)" class="sm-ac-history__clear"></span>
                </button>
              </li>
            </ul>
          </div>

          <div class="sm-ac-block" v-if="q.length > 2">
            <ul>
              <li v-for="item in correction">
                <button class="sm-ac-block__button" type="button" @click="toSearch(item.text, 0)" v-html="item.highlighted"></button>
              </li>
            </ul>
          </div>

          <div class="sm-ac-block">
            <ul>
              <li v-for="item in suggestion">
                <button class="sm-ac-block__button sm-ac-category" type="button" @click="toSearch(q, item.id)">
                  <span class="sm-ac-category__term">{{ q }}</span>
                  <span class="sm-ac-category__name">
                    В категории {{ item.name}} <i>({{ item.value }})</i>
                  </span>
                </button>
              </li>
            </ul>
          </div>

          <div class="sm-ac-block" v-if="sts.length > 0">
            <div class="sm-ac-block__title sm-ac-block__title_queries">Часто ищут</div>
            <ul>
              <li v-for="item in sts">
                <button class="sm-ac-block__button" type="button" @click="toSearch(item.st, 0)"><b></b>{{ item.st }}</button>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="!isMobile || (isMobile && mode !=='start')" class="sm-ac__set sm-ac__set_products">
          <div class="sm-ac-block">
            <div class="sm-ac-block__title sm-ac-block__title_products">Популярные товары</div>
            <ProductsGrid product_class="sm-product_ac" per_page="4" />
            <div class="sm-ac-find">
              <button v-show="isButtonVisible" @click="toSearch('', 0)" class="sm-ac-find__button">
                Смотреть все результаты
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductsGrid from './grid/products-grid.vue';
import {mapActions, mapGetters} from "vuex";

export default {
  name: "sm-ac",
  computed: {
    ...mapGetters("search", [
      "mode",
      "history",
      "isMobile",
      "autocompleteInfo",
      "q",
      "products"]),
    curMode: function () {
      return this.mode
    },
    storedHistory: function () {
      let q = this.q;
      let history = this.history
      history = JSON.parse(JSON.stringify(history))
      history = history.filter(item => {
        if(typeof item.name !== 'undefined') {
          return item.name.toLowerCase().indexOf(q) > -1
        }
        return false;
      })
      return history.slice(0, 4)
    },
    sts: function () {
      //@todo повтор
      let autocomplete = this.autocompleteInfo;
      autocomplete = JSON.parse(JSON.stringify(autocomplete))
      return autocomplete.sts.slice(0, 4);
    },
    correction: function () {
      let autocomplete = this.autocompleteInfo;
      autocomplete = JSON.parse(JSON.stringify(autocomplete))
      return autocomplete.correction.slice(0, 4);
    },
    suggestion: function () {
      let autocomplete = this.autocompleteInfo;
      autocomplete = JSON.parse(JSON.stringify(autocomplete))
      return autocomplete.categories.slice(0, 4);
    },
    isButtonVisible: function () {
      return (this.q !== '') && this.products.length;
    }
  },
  methods: {
    ...mapActions("search", [
      "changeMode",
      "deleteFromHistory",
      "getHistory",
      "doSearch",
      "setSearchMode",
      "setQString",
      "setQueryFilter",
      "selectCategory"
    ]),
    toSearch(q, category_id) {
      if(q === '') {
        q = this.$store.getters['search/q'];
      }
      if(category_id) {
        this.selectCategory(category_id)
      }
      this.setQueryFilter([]);
      this.setQString(q);
      this.doSearch().then(() => {
        // переключаем на страницу результатов
        this.setSearchMode();
      }).catch(err => {
        console.log(err);
      });
    }
  },
  components: {
    ProductsGrid
  },
  mounted() {
    this.getHistory();
  }
}
</script>